// extracted by mini-css-extract-plugin
export default {"red":"ChromatographyCheck_red__8Qli7","green":"ChromatographyCheck_green__SOVYo","title":"ChromatographyCheck_title__gtn1D","gasMnemonics":"ChromatographyCheck_gasMnemonics__jyxAe"};